import { generateTypes, getModelActionHandlers } from 'helpers/actions'

const modelName = 'uom'
const modelPlural = `${modelName}s`

export function get (id) {
  return {
    types: generateTypes(modelName),
    id,
    api: api => api(`${modelPlural}/${id}`)
  }
}

export function post (data) {
  return {
    types: generateTypes(`create_${modelName}`),
    data,
    api: api => api(modelPlural, { method: 'post', body: data }),
    onApiSuccess: (nextAction) => {
      nextAction.notify = { type: 'success', message: 'Successfully created.' }

      return nextAction
    }
  }
}

export function put (data, { redirect = true } = {}) {
  return {
    types: generateTypes(`update_${modelName}`),
    id: data.id,
    data,
    api: api => api(`${modelPlural}/${data.id}`, { method: 'put', body: data }),
    onApiSuccess: (nextAction) => {
      nextAction.redirectTo = redirect === true && `/${modelPlural}` || redirect
      nextAction.notify = { type: 'success', message: 'Successfully updated.' }

      return nextAction
    }
  }
}

export function destroy (id, { redirect = true } = {}) {
  return {
    types: generateTypes(`destroy_${modelName}`),
    id,
    api: api => api(`${modelPlural}/${id}`, { method: 'delete' }),
    onApiSuccess: (nextAction) => {
      nextAction.redirectTo = redirect === true && `/${modelPlural}` || redirect
      nextAction.notify = { type: 'success', message: `Deleted that ${modelName}.` }

      return nextAction
    }
  }
}

export const actions = {
  get,
  post,
  put,
  destroy
}

// Action Handlers
const initialState = {}
const ACTION_HANDLERS = getModelActionHandlers({ modelName })

export default function (state = initialState, action) {
  const handler = ACTION_HANDLERS[action.type]

  return handler ? handler(state, action) : state
}



// WEBPACK FOOTER //
// ./src/routes/Uoms/modules/uom.js